import React from 'react';
import { Button } from '../ui/Button';
import { HardHat } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 px-4 md:pt-20 md:pb-28 overflow-hidden bg-cement" data-id="element-29">
      <div className="max-w-6xl mx-auto" data-id="element-30">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-31">
          {/* Left Column — Text */}
          <div data-id="element-32">
            {/* Eyebrow */}
            <div className="flex items-center gap-2 mb-6" data-id="element-33">
              <HardHat className="h-6 w-6 text-amber-dark" strokeWidth={2.5} data-id="element-34" />
              <span className="font-heading font-bold text-amber-dark tracking-wider uppercase text-sm md:text-base" data-id="element-35">
                Para Oficiales y Albañiles Argentinos
              </span>
            </div>

            {/* Headlines */}
            <h1 className="font-heading font-bold text-5xl md:text-7xl text-charcoal leading-[1.1] mb-6 uppercase text-balance" data-id="element-36">
              Cómo dejar de ser Ayudante y convertirte en{' '}
              <span className="text-brick" data-id="element-37">Contratista</span>
            </h1>

            <div className="bg-charcoal text-white p-4 md:p-6 rounded-sm border-l-8 border-amber mb-10 shadow-hard" data-id="element-38">
              <h2 className="font-body font-semibold text-xl md:text-2xl leading-snug" data-id="element-39">
                Aprendé el sistema exacto para cobrar tus trabajos, manejar tu
                propia cuadrilla y proteger tu ganancia de la inflación sin
                miedo a perder clientes.
              </h2>
            </div>

            {/* Hook */}
            <div className="prose prose-lg md:prose-xl font-body text-charcoal mb-10" data-id="element-40">
              <p className="mb-4" data-id="element-41">
                Si sos oficial de albañilería, sabés que el problema no es el
                lomo que le ponés a la obra. El problema es que llegás al
                viernes y, después de pagarle a los ayudantes y al corralón,{' '}
                <strong data-id="element-42">a vos no te queda nada.</strong>
              </p>
              <p data-id="element-43">
                Estás cansado de "tirar un número" a ojo, de que el dueño de
                casa te pida rebaja y de terminar pagando vos para poder
                terminar el trabajo. No sos un mal trabajador; el tema es que{' '}
                <strong data-id="element-44">nadie te enseñó la parte del negocio.</strong>
              </p>
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row gap-4 items-start" data-id="element-45">
              <Button onClick={scrollToPricing} pulse={true} className="w-full sm:w-auto" data-id="element-46">
                Quiero el Manual Ahora
              </Button>
              <p className="text-sm font-body font-medium text-stone-500 mt-2 sm:mt-0 sm:ml-4 max-w-[200px]" data-id="element-47">
                Descarga inmediata. Lectura fácil en celular.
              </p>
            </div>
          </div>

          {/* Right Column — Product Mockup */}
          <div className="flex justify-center lg:justify-end order-first lg:order-last" data-id="element-48">
            <div className="relative w-full max-w-md lg:max-w-lg" data-id="element-49">
              <img src="https://cdn.magicpatterns.com/uploads/4fZGX8YuPCx79XmGxaVdJ6/Mockup.png" alt="El Manual del Contratista Pro — vista previa del producto digital en tablet" className="w-full h-auto drop-shadow-2xl" data-id="element-50" />
              {/* Badge overlay */}
              <div className="absolute -bottom-4 -left-4 bg-amber border-2 border-charcoal shadow-hard rounded-sm px-4 py-2 transform -rotate-3" data-id="element-51">
                <span className="font-heading font-bold text-charcoal text-sm md:text-base uppercase tracking-wide" data-id="element-52">
                  📲 Descarga Inmediata
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}